// extracted by mini-css-extract-plugin
export default {"investorBlock":"InvestorBlock_investorBlock__t-C5A","top":"InvestorBlock_top__BRIDa","avatar":"InvestorBlock_avatar__QmxdT","comment":"InvestorBlock_comment__M7UKx"};